import { Suspense } from 'react'
import Endpoint from './components/endpoint'
import './style.css'
import ReactDOM from 'react-dom/client'
import Preloader from './components/logic/preloader'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <>
        <Suspense fallback={<Preloader/>}>
            <Endpoint />
        </Suspense>
    </>
)